<template>
  <span>
    <div v-if="props.cancelar_processamento">
      <span class="badge badge-danger" v-b-tooltip.hover :title="$t('Criticado')">
        <font-awesome-icon :icon="['fa', 'minus']" />
      </span>
    </div>

    <div v-if="props.processado && !props.cancelar_processamento">
      <span class="badge badge-success" v-b-tooltip.hover :title="$t('Processado')">
        <font-awesome-icon :icon="['fa', 'check']" />
      </span>
    </div>

    <div v-if="props.processando && !props.cancelar_processamento">
      <span class="badge badge-info" v-b-tooltip.hover :title="$t('Processando')">
        <i class="ion ion-md-refresh"></i>
      </span>
    </div>

    <div v-if="!props.processado && !props.processando && !props.cancelar_processamento">
      <span class="badge badge-stack" v-b-tooltip.hover :title="$t('Aguardando Fila')">
        <i class="ion ion-logo-buffer"></i>
      </span>
    </div>
  </span>
</template>

<script>
export default {
  props: ['props']
};
</script>

<style lang="scss" scoped>
@import '@/_custom-variables.scss';
.badge-stack {
  background: $blue-dark;
  color: #fff;
}
</style>
